/* eslint-disable react/react-in-jsx-scope */
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableFooter from '@material-ui/core/TableFooter';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import arrayGroupBy from 'src/utils/arrayGroupBy';

const ComparisionTableMapValue = ({ array }) => {
  function createData(atribute, peso, valor, result, unidades) {
    return {
      atribute, peso, valor, result, unidades,
    };
  }

  const renderColumns = () => {
    const group = [];
    array.foto.forEach((element) => {
      const { unidades } = element;
      element.atributos.forEach((atributo) => {
        group.push(
          createData(
            atributo.atributo,
            atributo.peso,
            atributo.valor,
            array.result,
            +unidades,
          ),
        );
      });
    });
    const grouped = arrayGroupBy(group, 'atribute');
    return grouped;
  };

  const rows = renderColumns();

  return (
    <TableContainer component={Paper}>
      <Table size="small" aria-label="a dense table">
        <TableHead>
          <TableRow>
            <TableCell align="left">
              <strong>Beneficios </strong>
            </TableCell>
            {array?.foto?.map((row) => (
              <TableCell style={{ fontSize: 'smaller' }} align="right">
                <strong>
                  {row.linea.charAt(0) + row.linea.slice(1).toLowerCase()}
                </strong>
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {rows?.map((row) => (
            <TableRow key={row.id}>
              <TableCell
                component="th"
                scope="row"
                style={{ fontSize: 'smaller' }}
              >
                <strong>
                  {row[0].atribute}
                  {' '}
                  -
                  {row[0].peso}
                  %
                </strong>
              </TableCell>
              {row?.map((element) => (
                <>
                  <TableCell style={{ fontSize: 'smaller' }} align="right">
                    {element.valor}
                  </TableCell>
                </>
              ))}
            </TableRow>
          ))}
        </TableBody>
        <TableFooter>
          <TableRow key="nameM">
            <TableCell component="th" scope="row">
              <strong>Market share </strong>
            </TableCell>
            {rows[0]?.map((element) => (
              <TableCell align="right">
                <strong>
                  {(
                    ((+element.unidades || 0) / +element.result || 0) * 100
                  ).toFixed(2) || 0}
                  %
                  {' '}
                </strong>
              </TableCell>
            ))}
          </TableRow>
          <TableRow key="name2">
            <TableCell component="th" scope="row">
              <strong>V. Percibido</strong>
            </TableCell>
            {array?.foto?.map((element) => (
              <TableCell align="right">
                <strong>{element.vpercibido.toFixed(2)}</strong>
              </TableCell>
            ))}
          </TableRow>
        </TableFooter>
      </Table>
    </TableContainer>
  );
};

export default ComparisionTableMapValue;
